import React from 'react';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import axios from 'axios';
import Layout from '../../../layout/Layout';
import PFLCollectionPage from '../../../components/collections/PFLCollectionPage';
import { ENV } from '../../../constants/environments';
import { getSession } from 'next-auth/react';
import { SessionState } from '../../../types/state/reducers/authReducersTypes';
import cache from '../../../helpers/redis';
import errorRedirectHandler from '../../../helpers/errorRedirectHandler';
import ProductPageVisitPlugin from '../../../components/user-interest-analytics/ProductPageVisitPlugin';

import { useRouter } from 'next/router';

const PracticeFootageSceneClipPage: React.FC = (props: any) => {
  const router = useRouter();

  const headContent = {
    title: props.collection.name + ' VFX Practice Footage',
    keywords: [
      'stock footage collection',
      'vfx assets',
      'actionvfx',
      '2k assets',
      '4k assets',
      'green screen footage',
      'background plates',
      'practice footage for vfx'
    ].concat(props.collection.keywords),
    description: props.collection.short_description,
    og: {
      title: props.collection.name + ' VFX Practice Footage',
      image: props.collection.poster
    },
    canonical: router.asPath.split('?')[0].replace('/', ''),
  };
  return (
    <Layout head={headContent}>
      <PFLCollectionPage
        collection={props.collection}
        products={props.products}
        product={props.product}
        filters={props.filters}
        ownership={{}}
      />
      <ProductPageVisitPlugin product={props.collection} />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const session: SessionState = await getSession(ctx);
  const apiUrl: string = `${ENV.api.baseURL}`;

  let collection: any;
  let products: any;
  try {
    collection = await cache(
      `pfl_collections_3_${ctx.params.slug}_${session?.user?.id}_${session?.subscription?.id}}`,
      3600,
      async () => {
        const collectionsUrl: string = `${apiUrl}/scenes/${ctx.params.slug}`;
        const collectionParams = {};
        const collectionsRes = await axios.get(collectionsUrl, {
          params: collectionParams,
          headers: {
            'Content-Type': 'application/json',
            authorization: session?.user?.token
          }
        });
        return collectionsRes?.data;
      }
    );

    if (collection?.library?.id === 3) {
      return {
        redirect: {
          destination: `/3d/${collection.slug}`,
          permanent: false,
        }
      }
    }

    if (collection?.library?.id === 1) {
      return {
        redirect: {
          destination: `/collections/${collection.slug}`,
          permanent: false,
        }
      }
    }

    products = await cache(
      `avfx_pfl_products_1_${ctx.params.slug}_${session?.user?.id}_${session?.subscription?.id}`,
      3600,
      async () => {
        const productsRes = await axios.get(`${apiUrl}/collections/${collection.id}/products`, {
          headers: {
            'Content-Type': 'application/json',
            authorization: session?.user?.token
          }
        });
        return productsRes?.data;
      }
    );
  }
  catch (error) {
    return errorRedirectHandler(error);
  }

  const filtersUrl: string = `${apiUrl}/scenes/${collection.permalink}/filters-data`;
  let filters;
  try {
    filters = await cache(`pfl_filters_${collection.permalink}`, 3600, async () => {
      const filtersRes = await axios.get(filtersUrl);
      return filtersRes?.data?.data;
    });
  }
  catch (error) {}

  return {
    props: {
      collection: collection,
      products: products,
      product: products.find((p) => p.id == ctx.query.id) || null,
      filters: filters || []
    }
  };
};

export default PracticeFootageSceneClipPage;
